<button
  [class]="classes()"
  (click)="clickButton()"
  [attr.id]="buttonId()"
  [attr.type]="buttonType()"
  [disabled]="isDisabled()"
>
  <span>{{ label() }}</span>
  <div>
    @if (isProcessing()) {
      <div class="loader"></div>
    }
  </div>
</button>
